import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TaskCardTable = ({ table, isOpen, toggleTableState, taskCount, toggleButton, relatedParcels }) => {
  return (
    <Col key={'table_' + table.table_id} xs={12} md={6} lg={4}>
      <Card border="light" className="mb-3">
          <Card.Header className={`d-flex justify-content-between align-items-center ${!isOpen ? "round" : ""}`}>
              {/* Bal oldalon ikon és név */}
              <div className="d-flex align-items-center">
                <FontAwesomeIcon className="icon brown" icon={'location-dot'} />
                <strong className="ms-2">{table.name}</strong>
                {taskCount && <span className="table-name-counter brown-bg">{taskCount}</span>}
              </div>
              
              {/* Jobb oldalon gomb */}
              <div className="d-flex align-items-center">
                {toggleButton && (
                  <span className="btn button btn-flt-r ms-2" onClick={() => toggleTableState(table.table_id)}>
                    <FontAwesomeIcon icon="fa-solid fa-chevron-down" />
                  </span>
                )}
              </div>
          </Card.Header>
        {isOpen && (
          <Card.Body>
            <Row>
              <Col><span>Terület</span></Col>
              <Col><span>{table.area}</span></Col>
            </Row>
            <Row>
              <Col><span>Táblák száma</span></Col>
              <Col><span>{table.parcel_count}</span></Col>
            </Row>
            <Row>
              <Col><span>Kapcsolt táblák</span></Col>
              <Col><span className="strong-700">{relatedParcels}</span></Col>
            </Row>
            <Row>
              <Col><span>Tervezett fővetés</span></Col>
              <Col><span>{table.main_crop}</span></Col>
            </Row>
            <Row>
              <Col><span>Tervezett másodvetés</span></Col>
              <Col><span>{table.second_crop}</span></Col>
            </Row>
          </Card.Body>
        )}
      </Card>
    </Col>
  );
};

export default TaskCardTable;
